// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interactionlogdialog_featuredInteractionLogDialogItem__UhxHa {
    flex: 1 1;
    margin: 0px 20px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
    vertical-align: top;
}

.interactionlogdialog_featured__dEQ1q {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.interactionlogdialog_featuredItem__1QJn1 {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.interactionlogdialog_featuredTitleHeader__z5JXM {
    font-size: 17px;
    font-weight: bold;
}

.interactionlogdialog_dialogInputs__x2ACB {
    width: 100%;
}

.interactionlogdialog_dialogReadOnlyInputs__xh27H {
    width: 100%;
    z-index: 1000;
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/InteractionLogDialog/interactionlogdialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB","sourcesContent":[".featuredInteractionLogDialogItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    vertical-align: top;\r\n}\r\n\r\n.featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitleHeader {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.dialogReadOnlyInputs {\r\n    width: 100%;\r\n    z-index: 1000;\r\n    pointer-events: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredInteractionLogDialogItem": `interactionlogdialog_featuredInteractionLogDialogItem__UhxHa`,
	"featured": `interactionlogdialog_featured__dEQ1q`,
	"featuredItem": `interactionlogdialog_featuredItem__1QJn1`,
	"featuredTitleHeader": `interactionlogdialog_featuredTitleHeader__z5JXM`,
	"dialogInputs": `interactionlogdialog_dialogInputs__x2ACB`,
	"dialogReadOnlyInputs": `interactionlogdialog_dialogReadOnlyInputs__xh27H`
};
export default ___CSS_LOADER_EXPORT___;
